import { FormGridField } from "../../components/FormGrid";

export interface DateInputDefinition {
    name: string;
    id: string;
    placeholder: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
    showtime?: boolean;
    minutesinterval?: number;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildDateInputDefinition({
    name,
    id,
    placeholder,
    label,
    showtime,
    minutesinterval,
    schemaName,
    fieldOverrides
}: {
    name: string;
    id: string;
    placeholder: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
    showtime?: boolean;
    minutesinterval?: number;
}): DateInputDefinition {
    return {
        name,
        id,
        placeholder,
        label,
        showtime,
        minutesinterval,
        schemaName,
        fieldOverrides,
        buildFormGridField: _createDateInputField
    };
}

function _createDateInputField(schema): FormGridField {
    const {
        name,
        id,
        label,
        placeholder,
        schemaName,
        fieldOverrides,
        showtime,
        minutesinterval
    } = this;

    return {
        name,
        fieldType: "date",
        fieldOptions: {
            id,
            placeholder,
            inputType: "text",
            label,
            showtime,
            minutesinterval
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6",
        formSpacing: true,
        ...fieldOverrides
    };
}
